export default __webpack_public_path__ + "static/FORSINT-RoundLogo-5ba965ec6b58d3a22af0dd1383c59407.svg";